import { render, staticRenderFns } from "./FooterMiddle.vue?vue&type=template&id=1a1b2242&scoped=true"
import script from "./FooterMiddle.vue?vue&type=script&lang=js"
export * from "./FooterMiddle.vue?vue&type=script&lang=js"
import style0 from "./FooterMiddle.vue?vue&type=style&index=0&id=1a1b2242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b2242",
  null
  
)

export default component.exports